module.exports = __webpack_public_path__ + "static/media/youtube.666b3784.svg";